module.exports = __webpack_public_path__ + "img/male-child-figure.ec27f491.svg";